import React, { FC, useState } from "react";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { Name } from "../../../../models/Name";
import EmptyTableState from "../../../emptyTableState/EmptyTableState";
import List from "../../../list/list";
import { useFormikContext } from "formik";

interface CardTypeProps {
    onNext: (event: any) => void;
    onBack: (event: any) => void;
    setVingCardStepDescription: React.Dispatch<React.SetStateAction<{ cardType: string, door: string }>>;
    setVingCardType: React.Dispatch<React.SetStateAction<"staff" | "guest">>;
}

const CardType: FC<CardTypeProps> = ({ onNext, onBack, setVingCardStepDescription, setVingCardType}) => {
    const { translate } = useLocale();
    const cardTypes: Name[] = [
        { label: translate.byKey(TranslationKeys.staff), value: "staff" },
        { label: translate.byKey(TranslationKeys.guest), value: "guest" }
    ];
    const [task, setTask] = useState('');
    const [taskSelected, setTaskSelected] = useState(false);
    const {setFieldValue} = useFormikContext<any>();

    const itemSelected = (item: any) => {
        const selectedItem = item.props['data-item'];
        if (selectedItem) {
            setTaskSelected(true);
            setTask(selectedItem.value);
            setVingCardStepDescription(prevState => ({ ...prevState, cardType: selectedItem.label }));
            onNext({ task: selectedItem.value});
            setFieldValue('vingCardType', selectedItem.value);
            setVingCardType(selectedItem.value);
        }
    }

    const getListItems = (): { value: JSX.Element; isSelected: boolean; }[] => {
        return cardTypes.map(item => {
            return {
                value: (
                    <div className="flex flex-row items-center cursor-pointer select-none" data-item={item}>
                        <div className="p-2">{item.label}</div>
                    </div>
                ),
                isSelected: item.value === task
            };
        })
    }

    return <div className="fle flex-col pt-3 pr-3 h-full relative">
        <div className='w-full flex flex-col'>
            {cardTypes.length > 0 ?
                <List onSelect={(_, item) => itemSelected(item)} isStriped items={getListItems()} />
                : <EmptyTableState message={translate.byKey(TranslationKeys.noEnrolmentDeviceFound)} hideAddNewButton={true} />
            }
        </div>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5`}
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            {cardTypes.length > 0 && <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    id="nextButton"
                    data-cy="nextButton"
                    className={`py-1 px-5 secondary ${taskSelected ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    disabled={!taskSelected}
                    onClick={onNext}>{translate.byKey(TranslationKeys.next)}</button>
            </div>}
        </div>
    </div>
}

export default CardType;